import type { IdentidadeSonoraClipe } from '@/shared/types';

/** `random` injetável para teste determinístico; produção usa `Math.random`. */
export function selecionarClipeLocucao(
  clipes: IdentidadeSonoraClipe[],
  random: () => number = Math.random,
): IdentidadeSonoraClipe | null {
  if (clipes.length === 0) return null;
  const indice = Math.floor(random() * clipes.length);
  return clipes[Math.min(indice, clipes.length - 1)];
}
